import { getConfig } from "@/services/config";
import { Config } from "@/shared/types/config";
import { useConfigStore } from "@/store/useConfig";
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

export function useGetConfig() {
  const { setConfig } = useConfigStore();
  return useMutation<Config, AxiosError>({
    mutationKey: ["useGetConfig"],
    mutationFn: getConfig,
    onSuccess: (res) => {
      setConfig(res);
    },
  });
}
